import React from "react"
import PropTypes from "prop-types"
import { Card, Flex, Typography, Button } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import styles from "../../index.module.css"

const { Title } = Typography

export const ResourceCard = ({ title, buttonText, onAddClick, children }) => {
  return (
    <Card className="p-m">
      <Flex align="center" justify="space-between">
        <Title level={4}>{title}</Title>
        <Button onClick={onAddClick} icon={<PlusOutlined />} color="primary" variant="outlined" className={`${styles.addNewBtn} p-0`}>
          {buttonText}
        </Button>
      </Flex>
      {children}
    </Card>
  )
}

ResourceCard.propTypes = {
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onAddClick: PropTypes.func.isRequired,
  children: PropTypes.node
}
